import React from 'react';
import { useMatch } from 'react-router';
import PaidModal from '@/components/PaidModal';
// import { eventBus } from '@/service/event-bus';

// eslint-disable-next-line arrow-body-style
const RouterSideCar: React.FC = () => {
  const gamePageMatched = useMatch('games/codeclash');
  const gamePlaygroundMatched = useMatch({
    path: 'playground/codeclash',
    end: false,
  });
  const needDarkTheme = gamePageMatched || gamePlaygroundMatched;

  React.useEffect(() => {
    // eventBus.emit('THEME_CHANGE', needDarkTheme ? 'dark' : 'light');
  }, [needDarkTheme]);

  return <PaidModal />;
};

export default RouterSideCar;
